<ion-grid class="padding-l-r">
  <ion-row>
    <ion-col size="3" class="padding-l-r">
      <ion-text color="dark">
        <p>Género:</p>
      </ion-text>
    </ion-col>

    <ion-col
      size="2"
      (click)="sexoClick('mujer')"
      class="padding-l-r ion-text-center"
    >
      <ion-text [color]="mujerColor" id="mujer">
        <p>Soy</p>
        <p>Mujer</p>
      </ion-text>
    </ion-col>

    <ion-col
      size="3"
      (click)="sexoClick('hombre')"
      class="padding-l-r ion-text-center"
    >
      <ion-text [color]="hombreColor" id="hombre">
        <p>Soy</p>
        <p>Hombre</p>
      </ion-text>
    </ion-col>

    <ion-col
      size="4"
      (click)="sexoClick('no especificar')"
      class="padding-l-r ion-text-center"
    >
      <ion-text [color]="gayColor" id="gay">
        <p>No</p>
        <p>Especificar</p>
      </ion-text>
    </ion-col>
  </ion-row>
</ion-grid>
